import './LuckyWheel.less';
import React, { useState } from 'react';
import LuckyWheel from 'nike-ui/src/components/lucky-wheel/LuckyWheel';
import { DialogBody, DialogCloseButton, Docked, Fullscreen } from '@/ui/dialogs/Dialog';
import Article from '@/article/views/Article';
import { luckyWheelSpin$, luckyWheelWin$ } from 'nike-ui/src/components/lucky-wheel/h&s';
import { dispatch, useReframe } from 're-framejs';
import { handleClose } from '@/luckyWheel/h&s';
import { navigate } from '@/routing';
import { CASINO_GAME_DETAIL } from '@/routing/routes';

const LuckyWheelDialog = () => {
    const { subscribe } = useReframe();
    const spin = subscribe(luckyWheelSpin$);
    const winningSegment = subscribe(luckyWheelWin$);

    const [showInfoDialog, setShowInfoDialog] = useState(false);

    const handleCloseInfo = () => {
        setShowInfoDialog(false);
    };

    const onWin = (e, gameId) => {
        e.preventDefault();
        dispatch(handleClose);
        navigate(CASINO_GAME_DETAIL, { gameId });
    };

    return (
        <Fullscreen>
            {spin ? (
                <LuckyWheel
                    spin={spin}
                    winningSegment={winningSegment}
                    handleClose={() => dispatch(handleClose)}
                    handleInfoClick={() => setShowInfoDialog(true)}
                    navigateToWin={onWin}
                    onPhone
                />
            ) : null}
            {showInfoDialog ? (
                <Docked className="lucky-wheel-info-dialog" hideCloseButton>
                    <DialogCloseButton onClose={handleCloseInfo} />
                    <DialogBody>
                        <Article articleCode={'co-je-bezstarostne-koleso'} type={'marketing'} />
                    </DialogBody>
                </Docked>
            ) : null}
        </Fullscreen>
    );
};

export default LuckyWheelDialog;
